import React from 'react';

const PaymentsTable = ({ payments, openEdit, handleDelete, onPaymentPrint, onPaymentGeneratePDF }) => (
  <div className="admins-table-scroll">
  <table className="admins-table students-table">
    <thead>
      <tr>
        <th>Student</th>
        <th>Fee</th>
        <th>Amount</th>
        <th>Date</th>
        <th>Method</th>
        <th>Receipt Number</th>
        <th>Created By</th>
        <th>Updated By</th>
        <th>Created Date</th>
        <th>Updated Date</th>
        <th className="actions-header">Actions</th>
      </tr>
    </thead>
    <tbody>
      {payments.map(payment => (
        <tr key={payment._id}>
          <td>{payment.student ? payment.student.name : 'N/A'}</td>
          <td>{payment.fee ? `${payment.fee.class || ''} ${payment.fee.section || ''}`.trim() : 'N/A'}</td>
          <td>{payment.amount}</td>
          <td>{payment.date && new Date(payment.date).toLocaleDateString()}</td>
          <td>{payment.method}</td>
          <td>{payment.receiptNumber}</td>
          <td>{payment.createdBy ? payment.createdBy.name : 'N/A'}</td>
          <td>{payment.updatedBy ? payment.updatedBy.name : 'N/A'}</td>
        <td>{payment.createdAt ? new Date(payment.createdAt).toLocaleString() : 'N/A'}</td>
        <td>{payment.updatedAt ? new Date(payment.updatedAt).toLocaleString() : 'N/A'}</td>
          <td>
            <div className="admin-actions">
              <button className="edit-btn" onClick={() => openEdit(payment)}>Edit</button>
              <button className="delete-btn" onClick={() => handleDelete(payment._id)}>Delete</button>
              <button className="action-btn print" title="Print" onClick={() => onPaymentPrint(payment)}>
                <span role="img" aria-label="Print" style={{marginRight: '0.4em', display: 'inline'}}>🖨️</span> Print
              </button>
              <button className="action-btn pdf" title="Generate PDF" onClick={() => onPaymentGeneratePDF(payment)}>
                <span role="img" aria-label="PDF" style={{marginRight: '0.4em', display: 'inline'}}>📄</span> PDF
              </button>
            </div>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
  </div>
);

export default PaymentsTable; 